
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-2 h-2 bg-black rounded-full"></div>
            <span className="text-sm font-semibold tracking-wider uppercase text-gray-600">About DINARCO</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 font-serif">
            Building Trust Through<br />Technology
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="text-center p-8 relative">
            <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-purple-600 to-blue-600 rounded-2xl flex items-center justify-center">
              <i className="ri-shield-check-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Maximum Security</h3>
            <p className="text-gray-600 leading-relaxed">
              Our VPN uses military-grade AES-256 encryption to ensure your data remains completely private and secure from any threats.
            </p>
            {/* Vertical divider */}
            <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 w-px h-32 bg-gray-200"></div>
          </div>

          <div className="text-center p-8 relative">
            <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-purple-600 to-blue-600 rounded-2xl flex items-center justify-center">
              <i className="ri-lock-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Complete Privacy</h3>
            <p className="text-gray-600 leading-relaxed">
              We maintain a strict no-logs policy, ensuring your online activities remain completely anonymous and untraceable.
            </p>
            <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 w-px h-32 bg-gray-200"></div>
          </div>

          <div className="text-center p-8">
            <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-purple-600 to-blue-600 rounded-2xl flex items-center justify-center">
              <i className="ri-global-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Global Network</h3>
            <p className="text-gray-600 leading-relaxed">
              Access our worldwide network of high-speed servers, providing you with fast and reliable connections wherever you are.
            </p>
          </div>
        </div>

        <div className="bg-gray-50 rounded-3xl p-12 text-center">
          <p className="text-2xl text-gray-700 italic font-serif leading-relaxed max-w-4xl mx-auto">
            At DINARCO S.R.L., we are committed to protecting your digital freedom. Our mission is to provide secure, reliable, and user-friendly VPN solutions that empower individuals and businesses to navigate the internet safely and privately.
          </p>
        </div>
      </div>
    </section>
  );
}
